import { customListSchemaApi } from '../apis';

export const getSchema = (customListId: string) => {
  return customListSchemaApi.getCustomListSchema({
    customListId,
  });
};
